import React from 'react';
import './Blog.css';
import { Container } from 'react-bootstrap';

const Blog = ({ blog }) => {
    const { name, img, discretion, myBlog } = blog;
return (
    <section id="blogs">
        <Container>
            
            <div className="blog">
                <img src={img} alt="" />
                <h3>{name}</h3>
                <p>{discretion}</p>
                <a href={myBlog}><button>Read More</button></a>
            </div>

            <div className="view-read">
                <div className="view-comment mx-3">Views<br /> -----<br /> 1254</div>
                <div className="view-comment mx-3">Read<br /> -----<br />5</div>
                <div className="view-comment mx-3">Comments<br /> -----<br /> 12</div>
            </div>
            
        </Container>
    </section>
    );
};

export default Blog;